<template>
  <v-dialog max-width="1000px"
            persistent
            scrollable
            :value="value">
    <v-card color="kbLight">
      <v-toolbar color="kbLightBlue"
                 dark
                 flat
                 text>
        <v-toolbar-title class="text-h6">
          {{selectedField ? $t('general.extraCreatorEditField') : $t('general.extraCreatorCreateField')}}
        </v-toolbar-title>

        <v-spacer/>

        <v-btn @click="toggleModal()"
               icon>
          <v-icon>
            clear
          </v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-container class="pa-0" fluid>
          <v-form lazy-validation
                  ref="fieldForm"
                  :value="value">
            <v-row>
              <v-col cols="12" md="6">
                <v-text-field :label="$t('general.extraCreatorFieldName')"
                              color="kbDarkBlueText"
                              :rules="[rules.required]"
                              v-model="field.name">
                </v-text-field>
              </v-col>

              <v-col cols="12" md="6">
                <v-select :items="typeFields"
                          color="kbDarkBlueText"
                          :label="$t('general.extraCreatorFieldType')"
                          :rules="[rules.required]"
                          v-model="field.type">
                  <template slot="item" slot-scope="data">
                    <v-list-item-avatar>
                      <v-icon color="kbDarkBlueText">{{data.item.icon}}</v-icon>
                    </v-list-item-avatar>
                    <v-list-item-content>
                      <v-list-item-title class="kbDarkBlueText--text">{{data.item.text}}</v-list-item-title>
                    </v-list-item-content>
                  </template>
                </v-select>
              </v-col>

              <v-col cols="12" md="4">
                <v-select :items="fieldTypes"
                          color="kbDarkBlueText"
                          :label="$t('general.extraCreatorFieldAccess')"
                          :rules="[rules.required]"
                          v-model="field.access">
                  <template slot="item" slot-scope="data">
                    <v-list-item-avatar>
                      <v-tooltip bottom max-width="250px">
                        <template v-slot:activator="{ on }">
                          <v-icon color="kbDarkBlueText" v-on="on">
                            info
                          </v-icon>
                        </template>
                        <span class="kbDarkBlueText--text">
                                                    {{data.item.help}}
                                                </span>
                      </v-tooltip>
                    </v-list-item-avatar>
                    <v-list-item-content>
                      <v-list-item-title>{{data.item.text}}</v-list-item-title>
                    </v-list-item-content>
                  </template>
                </v-select>
              </v-col>
              <v-col cols="12" md="4">
                <v-combobox
                  v-model="field.tags"
                  :items="tags"
                  :search-input.sync="search"
                  hide-selected
                  color="kbDarkBlueText"
                  :label="$t('general.extraCreatorAddTags')"
                  multiple
                  persistent-hint
                  small-chips
                >
                  <template v-slot:no-data>
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-title>
                          {{$t('general.extraCreatorMessageEnterTag1')}} "<strong>{{ search }}</strong>".  {{$t('general.extraCreatorMessageEnterTag2')}} <kbd>enter</kbd>  {{$t('general.extraCreatorMessageEnterTag3')}}
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </template>
                </v-combobox>
              </v-col>

              <v-col cols="12" md="4">
                <v-switch
                  color="kbBlue"
                  :label="$t('general.showFieldInPeopleFilters')"
                  v-model="field.visibleOnSearch"
                ></v-switch>
              </v-col>

              <div class="flex" v-if="field.type === 'checkbox' || field.type === 'radio' || field.type === 'select'">
                <v-col cols="12" class="grey--text text--darken-1">
                  {{ $t('general.extraCreatorAddOptions') }}
                </v-col>

                <v-col cols="12" v-for="(option, indexOption) in field.options" :key="indexOption">
                  <v-row class="px-1"  >
                    <v-text-field :placeholder="$t('general.extraCreatorOption')"
                                  color="kbDarkBlueText"
                                  :rules="[rules.required]"
                                  v-model="option.name">
                      <template #append>
                        <v-btn icon
                               color="red"
                               text
                               @click="deleteOptionItem(indexOption)">
                          <v-icon>
                            clear
                          </v-icon>
                        </v-btn>

                        <v-btn icon
                               color="kbDarkBlueText"
                               text
                               @click="addOptionItem()"
                               v-if="indexOption === field.options.length - 1">
                          <v-icon>
                            add
                          </v-icon>
                        </v-btn>
                      </template>
                    </v-text-field>
                  </v-row>
                </v-col>
              </div>
            </v-row>
          </v-form>
        </v-container>
      </v-card-text>

      <v-divider/>

      <v-card-actions class="mt-2">
        <v-spacer/>
        <v-btn @click="toggleModal()"
               class="mr-2"
               color="error"
               outlined>
          {{ $t('general.cancel') }}
        </v-btn>

        <v-btn @click="submit()"
               color="kbLightBlue"
               dark
               :loading="loading">
          {{selectedField ? $t('general.edit') : $t('general.add')}}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import notifications from '@/libs/notifications'
import rules from '@/libs/rules'
import { mapState } from 'vuex'
import arraysAndJsonsHelpers from '@/libs/arraysAndJsonsHelpers'
export default {
  data: () => ({
    field: {
      access: '',
      name: '',
      type: '',
      options: [],
      tags: [],
      visibleOnSearch: true
    },
    loading: false,
    rules,
    search: null
  }),
  methods: {
    addOptionItem () {
      this.field.options.push({
        name: ''
      })
    },
    async createCustomExtradata () {
      try {
        const data = {
          extraDataArray: [this.field]
        }
        await this.$store.dispatch('createCustomExtradata', data)
        await this.$store.dispatch('getAppCustomExtradatas')
        await this.$store.dispatch('getAppTagsOfCustomExtraData')
        notifications.success(this.$t('general.fieldSuccessfullyCreated'))
        this.loading = false
        this.toggleModal()
        return true
      } catch (e) {
        console.error(e)
        this.loading = false
      }
    },
    deleteOptionItem (index) {
      if (this.field.options.length > 1) this.field.options.splice(index, 1)
    },
    async submit () {
      try {
        if (!this.$refs.fieldForm.validate()) return
        this.loading = true

        this.selectedField ? this.updateCustomExtradata() : this.createCustomExtradata()
      } catch (e) {
        console.error(e)
        this.loading = false
      }
    },
    toggleModal () {
      this.$refs.fieldForm.reset()
      this.$emit('clear')
      this.field = {
        access: '',
        name: '',
        type: '',
        options: [],
        tags: [],
        visibleOnSearch: true
      }
      this.$emit('input', false)
    },
    async updateCustomExtradata () {
      try {
        if (!this.$refs.fieldForm.validate()) return
        this.loading = true

        await this.$store.dispatch('updateCustomExtradata', this.field)
        await this.$store.dispatch('getAppCustomExtradatas')
        await this.$store.dispatch('getAppTagsOfCustomExtraData')
        notifications.success(this.$t('general.fieldSuccessfullyUpdated'))
        this.loading = false
        this.toggleModal()
        return true
      } catch (e) {
        console.error(e)
        this.loading = false
      }
    }
  },
  computed: {
    ...mapState({
      tags: state => state.apps.tags
    }),
    typeFields: function () {
      return [
        { icon: 'short_text', text: this.$t('general.extraCreatorShortText'), value: 'text' },
        { icon: 'mdi-text-subject', text: this.$t('general.extraCreatorLongText'), value: 'textLong' },
        { icon: 'mdi-numeric', text: this.$t('general.numeric'), value: 'numeric' },
        { icon: 'arrow_drop_down_circle', text: this.$t('general.extraCreatorList'), value: 'select' },
        { icon: 'mdi-radiobox-marked', text: this.$t('general.extraCreatorRadioList'), value: 'radio' },
        { icon: 'mdi-checkbox-marked', text: this.$t('general.extraCreatorCheckList'), value: 'checkbox' },
        { icon: 'mdi-at', text: this.$t('general.extraCreatorEmail'), value: 'email' },
        { icon: 'feather-dollar-sign', text: this.$t('general.money'), value: 'money' },
        { icon: 'mdi-phone', text: this.$t('general.phone'), value: 'phone' },
        { icon: 'mdi-calendar', text: this.$t('general.date'), value: 'date' },
        { icon: 'mdi-calendar-clock', text: this.$t('general.datetime'), value: 'dateTime' }
      ]
    },
    fieldTypes: function () {
      return [
        {
          help: this.$t('general.extraCreatorApplicationInfo'),
          text: this.$t('general.extraCreatorApplication'),
          value: 'app'
        },
        {
          help: this.$t('general.extraCreatorPersonInfo'),
          text: this.$t('general.person'),
          value: 'user'
        }
      ]
    }
  },
  props: ['selectedField', 'value'],
  watch: {
    appCustomExtradatas (value) {
      if (!value) return
      value.forEach(item => {
        this.fields.push(item)
      })
    },
    'field.type' (value) {
      if (JSON.stringify(this.field.options) === '{}') {
        this.$set(this.field, 'options', [])
      }
      if (JSON.stringify(this.field.tags) === '{}') {
        this.$set(this.field, 'tags', [])
      }

      if (value === 'checkbox' && this.field.options.length === 0) {
        this.addOptionItem()
      }

      if (value === 'radio' && this.field.options.length === 0) {
        this.addOptionItem()
      }

      if (value === 'select' && this.field.options.length === 0) {
        this.addOptionItem()
      }
    },
    selectedField (value) {
      if (value && typeof value === 'object') {
        this.field = arraysAndJsonsHelpers.copyJson(value)
      }
    },
    'field.tags' (val) {
      if (val.length > 5) {
        this.$nextTick(() => this.field.tags.pop())
      }
    }
  }
}
</script>
